import React, { useCallback, useContext, useEffect, useState } from 'react';
import GenerationPartialPaymentStep from './Steps/GenerationPartialPaymentStep.js';
import ValuePartialPaymentStep from './Steps/ValuePartialPaymentStep.js';
import { UserContext } from '../../../Contexts/UserContext.js';
import _get from 'lodash/get';
import { GetContractDebtsAPI } from '../../../API/Debts/DebtsAPI.js';
import { getBrillaCurrentDebtValue } from '../helpers/helpers.js';
import { ContractSelectedContext } from '../../../Contexts/ContractsContext.js';

const PartialPaymentDialogStep = {
  Input: 'input',
  Generation: 'generation'
};

const DebtPartialPaymentDialog = props => {
  const {
    open,
    onClose,
    requestCallback,
    paymentData,
    partialValueStepTitle = 'Generación de cupón',
    description = null,
    toDeferreds = false,
    addDeferreds = undefined
  } = props;

  const { contractId, maxValue = null } = paymentData;

  const currentUser = useContext(UserContext);
  const authToken = _get(currentUser, 'token');
  const selectedContract = useContext(ContractSelectedContext);

  const [currentBrillaDebtValue, setCurrentBrillaDebtValue] = useState(null);
  const [currentDebtValueExist, setCurrentDebtValueExist] = useState(false);
  const [step, setStep] = useState({
    type: 'input',
    data: { ...paymentData, currentDebtValueExist }
  });
  const [loading, setLoading] = useState(false);

  const setNextModal = useCallback(({ type, data }) => {
    setStep({ type, data });
  }, []);

  const currentStep = step.type;

  useEffect(() => {
    const fetchData = async () => {
      const debtContractId = contractId || selectedContract.id;

      setLoading(true);
      const debtsResponse = await GetContractDebtsAPI(
        authToken,
        debtContractId
      );

      if (debtsResponse.success) {
        const responseData = debtsResponse.data.data;
        setCurrentBrillaDebtValue(getBrillaCurrentDebtValue(responseData));
        setCurrentDebtValueExist(true);
      }

      setLoading(false);
    };

    if (!maxValue) {
      fetchData();
    }
  }, [authToken, contractId, maxValue, selectedContract]);

  useEffect(() => {
    if (!maxValue && currentBrillaDebtValue !== null) {
      setStep({
        type: 'input',
        data: {
          ...paymentData,
          maxValue: currentBrillaDebtValue,
          currentDebtValueExist
        }
      });
    }
  }, [currentBrillaDebtValue, paymentData, currentDebtValueExist, maxValue]);

  if (!open) {
    return <></>;
  }

  return (
    <>
      {currentStep === PartialPaymentDialogStep.Input && (
        <ValuePartialPaymentStep
          title={partialValueStepTitle}
          description={description}
          open={true}
          onClose={onClose}
          setNextModal={setNextModal}
          requestCallback={requestCallback}
          step={step}
          authToken={authToken}
          isParentLoading={loading}
          toDeferreds={toDeferreds}
          addDeferreds={addDeferreds}
        />
      )}
      {currentStep === PartialPaymentDialogStep.Generation && (
        <GenerationPartialPaymentStep
          title="Generación de cupón"
          open={true}
          onClose={onClose}
          step={step}
          authToken={authToken}
        />
      )}
    </>
  );
};

export default DebtPartialPaymentDialog;
